import api from "../../../axiosConfig";

export const whatsappAudienceApi = {
  estimate: async ({
    q = "",
    source = null,
    status = null,
    contactGroupId = null,
    limit = 200,
    preferredLimit = null,
    excludeRecent = true,
    days = 7,
    segment = "",
    audienceKind = null,
    includeMyContacts = null,
    targetAudience = "all",
  } = {}) => {
    const res = await api.post("/whatsapp/contacts/estimate", {
      filters: {
        q,
        source,
        status,
        contact_group_id: contactGroupId || null,
        limit,
        preferred_limit: preferredLimit || null,
        target_audience: targetAudience || "all",
        ...(audienceKind ? { audience_kind: audienceKind } : {}),
        ...(includeMyContacts ? { include_my_contacts: true } : {}),
      },
      exclude_recent: excludeRecent,
      days,
      segment,
    });

    return res.data;
  },
};
